import { useState } from "react";
import { AUTH_STORAGE_KEY, AUTH_STORAGE_VALUE, FIXED_PASSWORD } from "../constants/auth";
import "./ViewPage.css";

function LockIcon() {
  return (
    <svg viewBox="0 0 24 24" className="auth-lock-icon" fill="none" aria-hidden="true">
      <path
        d="M7 10V7a5 5 0 0 1 10 0v3"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <rect x="5" y="10" width="14" height="10" rx="1.8" stroke="currentColor" strokeWidth="1.6" />
      <circle cx="12" cy="15" r="1.1" fill="currentColor" />
    </svg>
  );
}

function EyeIcon({ visible }) {
  if (visible) {
    return (
      <svg viewBox="0 0 24 24" className="auth-eye-icon" fill="none" aria-hidden="true">
        <path
          d="M2.5 12s3.6-6 9.5-6 9.5 6 9.5 6-3.6 6-9.5 6-9.5-6-9.5-6Z"
          stroke="currentColor"
          strokeWidth="1.6"
        />
        <circle cx="12" cy="12" r="2.4" stroke="currentColor" strokeWidth="1.6" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 24 24" className="auth-eye-icon" fill="none" aria-hidden="true">
      <path
        d="M2.5 12s3.6-6 9.5-6c2.3 0 4.3.9 5.9 2.1M21.5 12s-3.6 6-9.5 6c-2.3 0-4.3-.9-5.9-2.1"
        stroke="currentColor"
        strokeWidth="1.6"
      />
      <path d="m4 4 16 16" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}

export default function PasswordPage({ onAuthenticated }) {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = (event) => {
    event.preventDefault();

    if (password === FIXED_PASSWORD) {
      localStorage.setItem(AUTH_STORAGE_KEY, AUTH_STORAGE_VALUE);
      onAuthenticated?.();
      return;
    }

    setError("Invalid password");
  };

  return (
    <main className="auth-gate">
      <form className="auth-card" onSubmit={onSubmit}>
        <div className="auth-lock-wrap" aria-hidden="true">
          <div className="auth-lock-box">
            <LockIcon />
          </div>
          <span className="auth-lock-dot auth-lock-dot--tl" />
          <span className="auth-lock-dot auth-lock-dot--br" />
        </div>

        <h1 className="auth-title">ENTER PASSWORD</h1>

        <div className="auth-input-shell">
          <input
            id="password-input"
            className="auth-input"
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(event) => {
              setPassword(event.target.value);
              if (error) {
                setError("");
              }
            }}
            autoComplete="current-password"
            aria-label="Password"
            placeholder="******"
            required
          />
          <button
            type="button"
            className="auth-eye-btn"
            onClick={() => setShowPassword((prev) => !prev)}
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            <EyeIcon visible={showPassword} />
          </button>
        </div>

        {error ? <p className="auth-error">{error}</p> : null}

        <button type="submit" className="auth-submit">
          SUBMIT <span className="auth-submit-arrow">→</span>
        </button>
      </form>
    </main>
  );
}
